module.exports = __webpack_public_path__ + "static/media/repeat.1a42ba64.svg";